import axios from 'axios';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import Footer from '../components/Footer';
import Header from '../components/Header';
import { BASEURL, RZP_KEY } from '../Config';
import { getCartProducts, getisAuthenticated, getUserData, getSchool } from '../modules/reducers';
import { loginUser, loginWithData, clearCart, setParentSchools } from '../modules/actions';
import swal from 'sweetalert';

class Checkout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Cart
            cartProducts: [],
            orderTotal: 0,
            classId: '',
            className: '',
            // Step management
            step: 1,
            isConfirmed: false,
            isCheckingEmail: false,
            // Parent data
            parentId: null,
            parentName: '',
            email: '',
            phone: '',
            state: this.props.school.state,
            address: '',
            gmaps: '',
            zip: '',
            // Student data
            studentId: null,
            studentName: '',
            surname: '',
            existingStudents: [],
            selectedStudentId: '',
            studentSelectionMade: false,
            errors: {}
        };
    }

    componentDidMount() {
        if (Object.keys(this.props.user).length > 0 && this.props.user.email) {
            this.setState({ email: this.props.user.email });
        }
        const products = this.props.products;
        let orderTotal = 0;
        products.forEach((item) => {
            orderTotal = orderTotal + item.price;
        });
        this.setState({
            cartProducts: products,
            orderTotal,
            classId: products[0]?.classId || '',
            className: products[0]?.className || '',
        });
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
            isConfirmed: false,
        });
    }

    async handleNext() {
        const email = this.state.email.trim();
        if (!email) {
            this.setState({ errors: { email: 'Email is required' } });
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.setState({ errors: { email: 'Invalid email format' } });
            return;
        }
        this.setState({ isCheckingEmail: true, errors: {} });

        try {
            const res = await axios.get(`${BASEURL}/api/v1/parent/getByEmail/${email}`);
            if (res.status === 200) {
                const parentData = res.data;
                let students = [];
                try {
                    const studentsRes = await axios.get(
                        `${BASEURL}/api/v1/student/getByParent/${parentData._id}/${this.props.school._id}`
                    );
                    if (studentsRes.status === 200) {
                        students = studentsRes.data;
                    }
                } catch (e) {
                    students = [];
                }
                this.setState({
                    parentId: parentData._id,
                    parentName: parentData.parentName,
                    phone: parentData.phone,
                    address: parentData.address || '',
                    state: this.props.school.state,
                    zip: parentData.zip || '',
                    gmaps: parentData.gmapsLink || '',
                    existingStudents: students,
                    step: 2,
                    isCheckingEmail: false,
                    isConfirmed: false,
                });
            }
        } catch (err) {
            // Parent not found — new parent flow, clear all previously filled details
            this.setState({
                parentId: null,
                parentName: '',
                phone: '',
                address: '',
                gmaps: '',
                zip: '',
                state: this.props.school.state,
                existingStudents: [],
                selectedStudentId: '',
                studentSelectionMade: false,
                studentId: null,
                studentName: '',
                surname: '',
                step: 2,
                isCheckingEmail: false,
                isConfirmed: false,
            });
        }
    }

    handleStudentSelect(e) {
        const selectedId = e.target.value;
        // "-- Select a student --" placeholder — do nothing
        if (!selectedId) {
            return;
        }
        // "+ Add new student" option
        if (selectedId === '__new__') {
            this.setState({
                selectedStudentId: '__new__',
                studentId: null,
                studentName: '',
                surname: '',
                isConfirmed: false,
                studentSelectionMade: true,
            });
            return;
        }
        const selected = this.state.existingStudents.find(s => s._id === selectedId);
        if (selected) {
            const studentClassId = selected.classId;
            const cartClassId = this.state.classId;
            if (studentClassId && cartClassId && studentClassId !== cartClassId) {
                swal({
                    title: 'Class Mismatch',
                    text: `This student is registered for "${selected.className || 'another class'}". Do you want to create a new student record for "${this.state.className}"?`,
                    icon: 'warning',
                    buttons: ['Cancel', 'Yes, Create New Record'],
                }).then((confirm) => {
                    if (confirm) {
                        // Keep the name pre-filled but clear studentId so a new record is created for the cart's class
                        this.setState({
                            selectedStudentId: selectedId,
                            studentId: null,
                            studentName: selected.studentName,
                            surname: selected.surname || '',
                            isConfirmed: false,
                            studentSelectionMade: true,
                        });
                    } else {
                        this.setState({
                            selectedStudentId: '',
                            studentId: null,
                            studentName: '',
                            surname: '',
                            isConfirmed: false,
                            studentSelectionMade: false,
                        });
                    }
                });
                return;
            }
            this.setState({
                selectedStudentId: selectedId,
                studentId: selectedId,
                studentName: selected.studentName,
                surname: selected.surname || '',
                isConfirmed: false,
                studentSelectionMade: true,
            });
        }
    }

    handleConfirm() {
        let errors = {};
        if (!this.state.studentName.trim()) {
            errors.studentName = 'Student name is required';
        }
        if (!this.state.parentName.trim()) {
            errors.parentName = 'Parent name is required';
        }
        if (!this.state.phone.trim()) {
            errors.phone = 'Phone number is required';
        } else if (!/^[6-9]\d{9}$/.test(this.state.phone)) {
            errors.phone = 'Invalid phone number format';
        }
        if (!this.state.address.trim()) {
            errors.address = 'Address is required';
        }
        if (!this.state.zip.trim()) {
            errors.zip = 'ZIP code is required';
        } else if (!/^\d{6}$/.test(this.state.zip)) {
            errors.zip = 'Invalid ZIP code format';
        }
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            this.setState({ isConfirmed: true });
        } else {
            swal('Error', 'Please resolve all the errors before confirming', 'error');
        }
    }

    async handlePlaceOrder() {
        const isUat = window.location.origin.includes('uat') && window.location.pathname.includes('edukart');
        if (isUat) {
            swal('Not Allowed', 'Placing orders is disabled on UAT environment', 'warning');
            return;
        }
        if (this.state.orderTotal === 0) {
            swal('Warning', 'Please add products into the cart to place the order', 'warning');
            return;
        }

        const { classId, className } = this.state;
        let parentId = this.state.parentId;
        let studentId = this.state.studentId;

        const inputForRazorpay = {
            schoolId: this.props.school._id,
            schoolName: this.props.school.name,
            studentName: this.state.studentName.trim(),
            surname: this.state.surname.trim(),
            parentName: this.state.parentName.trim(),
            email: this.state.email,
            phone: this.state.phone,
            state: this.state.state,
            address: this.state.address,
            zip: this.state.zip,
            gmapsLink: this.state.gmaps,
            products: this.state.cartProducts,
            orderTotal: this.state.orderTotal,
            shippingCharges: (this.state.cartProducts[0]?.orderType === 'uniformProducts' ? (this.props.school.uniformCharges || 0) : (this.props.school.shippingCharges || 0)) * this.state.cartProducts.length,
            amount: this.state.orderTotal + ((this.state.cartProducts[0]?.orderType === 'uniformProducts' ? (this.props.school.uniformCharges || 0) : (this.props.school.shippingCharges || 0)) * this.state.cartProducts.length),
        };

        // 1. Create or update parent
        if (!parentId) {
            try {
                const res = await axios.post(`${BASEURL}/api/v1/parent`, {
                    parentName: this.state.parentName.trim(),
                    email: this.state.email,
                    phone: this.state.phone,
                    state: this.state.state,
                    address: this.state.address,
                    zip: this.state.zip,
                    gmapsLink: this.state.gmaps,
                    schoolId: this.props.school._id,
                });
                if (res.status === 200) {
                    parentId = res.data._id;
                    this.setState({ parentId });
                }
            } catch (err) {
                console.log('create parent error', err);
                swal('Error', 'Failed to save parent details. Please try again.', 'error');
                return;
            }
        } else {
            try {
                await axios.put(`${BASEURL}/api/v1/parent/update`, {
                    id: parentId,
                    parentName: this.state.parentName.trim(),
                    phone: this.state.phone,
                    state: this.state.state,
                    address: this.state.address,
                    zip: this.state.zip,
                    gmapsLink: this.state.gmaps,
                });
            } catch (err) {
                console.log('update parent error', err);
            }
        }

        // 2. Create student if not selected from existing
        if (!studentId) {
            try {
                const res = await axios.post(`${BASEURL}/api/v1/student`, {
                    studentName: this.state.studentName.trim(),
                    surname: this.state.surname.trim(),
                    schoolId: this.props.school._id,
                    parentId,
                    classId,
                    className,
                });
                if (res.status === 200) {
                    studentId = res.data._id;
                    this.setState({ studentId });
                }
            } catch (err) {
                console.log('create student error', err);
                swal('Error', 'Failed to save student details. Please try again.', 'error');
                return;
            }
        }

        inputForRazorpay.studentId = studentId;
        inputForRazorpay.parentId = parentId;

        // Log in the user so isAuthenticated is true on the Thank You page
        this.props.loginWithData({
            _id: studentId,
            studentName: this.state.studentName.trim(),
            surname: this.state.surname.trim(),
            parentId,
            email: this.state.email,
            phone: this.state.phone,
            schoolId: this.props.school._id,
        });

        await this.displayRazorpay(inputForRazorpay);
    }

    loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    }

    async displayRazorpay(input) {
        const res = await this.loadScript('https://checkout.razorpay.com/v1/checkout.js');
        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?');
            return;
        }
        let data = {};
        await axios.post(`${BASEURL}/api/v1/payment/razorpay`, input)
            .then((res) => {
                data = res.data;
            });

        const options = {
            key: RZP_KEY,
            currency: data.currency,
            amount: data.amount.toString(),
            order_id: data.id,
            name: 'Pelican Billing',
            description: 'Thank you for purchasing our products',
            image: 'images/pelican_icon.jpg',
            redirect: false,
            handler: async (response) => {
                try {
                    const pid = this.state.parentId;
                    if (pid) {
                        const schoolsRes = await axios.get(`${BASEURL}/api/v1/parent/getSchools/${pid}`);
                        const schools = schoolsRes.data || [];
                        this.props.setParentSchools(schools);
                    }
                } catch (e) {
                    // non-fatal — proceed to thank you regardless
                }
                window.location.href = "thankyou";
            },
            prefill: {
                name: this.state.studentName,
                email: this.state.email,
                contact: this.state.phone,
            },
            config: {
                display: {
                    blocks: {
                        banks: {
                            name: "Choose payment method",
                            instruments: [
                                { method: "upi" },
                                { method: "netbanking" },
                                { method: "wallet" },
                                { method: "card" },
                            ],
                        },
                    },
                    sequence: ["block.banks"],
                    preferences: {
                        show_default_blocks: false,
                    },
                },
                method: {
                    netbanking: "1",
                    card: "1",
                    upi: "1",
                    wallet: "1",
                    emi: "0",
                    paylater: "0",
                },
            }
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.on('payment.failed', function (response) {
            console.error("Payment failed:", response);
            alert(`Payment failed: ${response.error.reason}`);
        });
        paymentObject.open();
    }

    renderStep1() {
        const { errors, email, isCheckingEmail } = this.state;
        return (
            <div>
                <h2 className="h3 mb-3 text-black">Step 1 of 2: Enter your email</h2>
                <p className="text-muted small mb-3">
                    We'll check if you have an existing account and pre-fill your details.
                </p>
                <div className="p-3 p-lg-5 border">
                    <div className="form-group row">
                        <div className="col-md-12">
                            <label htmlFor="c_email_address" className="text-black">
                                Email Address <span className="text-danger">*</span>
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                id="c_email_address"
                                name="email"
                                placeholder="Enter Email Address"
                                onChange={(e) => this.handleChange(e)}
                                value={email}
                            />
                            {errors.email && <small className="text-danger">{errors.email}</small>}
                        </div>
                    </div>
                    <div className="form-group row mt-3 mb-0">
                        <div className="col-md-12">
                            <button
                                className="btn btn-primary btn-lg btn-block"
                                onClick={() => this.handleNext()}
                                disabled={isCheckingEmail}
                            >
                                {isCheckingEmail ? 'Checking...' : 'Next \u2192'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderStep2() {
        const { errors, existingStudents, selectedStudentId, studentSelectionMade, isConfirmed } = this.state;
        const showForm = existingStudents.length === 0 || studentSelectionMade;
        return (
            <div>
                <h2 className="h3 mb-3 text-black">Step 2 of 2: Billing Details</h2>
                {this.state.className && (
                    <div className="mb-3">
                        <span className="text-black font-weight-bold">Selected Class: </span>
                        <span className="text-primary font-weight-bold">{this.state.className}</span>
                    </div>
                )}
                <div className="p-3 p-lg-5 border">
                    {existingStudents.length > 0 && (
                        <div className="form-group row">
                            <div className="col-md-12">
                                <label className="text-black">Select Student</label>
                                <select
                                    className="form-control"
                                    onChange={(e) => this.handleStudentSelect(e)}
                                    value={selectedStudentId}
                                >
                                    <option value="">-- Select a student --</option>
                                    {existingStudents.map(s => (
                                        <option key={s._id} value={s._id}>
                                            {s.studentName}{s.surname ? ` ${s.surname}` : ''}{s.className ? ` (${s.className})` : ''}
                                        </option>
                                    ))}
                                    <option value="__new__">+ Add new student</option>
                                </select>
                            </div>
                        </div>
                    )}

                    {!showForm && (
                        <p className="text-muted text-center mt-2">Please select a student above to continue.</p>
                    )}

                    {showForm && (
                        <>
                        <div className="form-group row">
                            <div className="col-md-6">
                                <label htmlFor="c_studentName" className="text-black">
                                    Student Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="c_studentName"
                                    name="studentName"
                                    placeholder="Enter Student Name"
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.studentName}
                                />
                                {errors.studentName && <small className="text-danger">{errors.studentName}</small>}
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="c_surname" className="text-black">Surname</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="c_surname"
                                    name="surname"
                                    placeholder="Enter Surname"
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.surname}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <label htmlFor="c_parentName" className="text-black">
                                    Parent Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="c_parentName"
                                    name="parentName"
                                    placeholder="Enter Parent Name"
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.parentName}
                                />
                                {errors.parentName && <small className="text-danger">{errors.parentName}</small>}
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <label htmlFor="c_phone" className="text-black">
                                    Phone <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="c_phone"
                                    name="phone"
                                    placeholder="Enter Phone Number"
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.phone}
                                />
                                {errors.phone && <small className="text-danger">{errors.phone}</small>}
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <label htmlFor="c_address" className="text-black">
                                    Address <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    id="c_address"
                                    name="address"
                                    placeholder="Enter Address"
                                    rows={3}
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.address}
                                />
                                {errors.address && <small className="text-danger">{errors.address}</small>}
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <label htmlFor="gmaps" className="text-black">Google Maps Link (Optional)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="gmaps"
                                    name="gmaps"
                                    placeholder="Enter Google Maps link"
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.gmaps}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <label htmlFor="c_postal_zip" className="text-black">
                                    Postal / ZIP Code <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="c_postal_zip"
                                    name="zip"
                                    placeholder="Enter ZIP Code"
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.zip}
                                />
                                {errors.zip && <small className="text-danger">{errors.zip}</small>}
                            </div>
                        </div>

                        <div className="form-group row mt-4 mb-0">
                            <div className="col-md-5">
                                <button
                                    className="btn btn-outline-secondary btn-lg btn-block"
                                    onClick={() => this.setState({ step: 1, isConfirmed: false, errors: {}, studentSelectionMade: false, selectedStudentId: '' })}
                                >
                                    &#8592; Back
                                </button>
                            </div>
                            <div className="col-md-7">
                                <button
                                    className={`btn btn-lg btn-block ${isConfirmed ? 'btn-success' : 'btn-warning'}`}
                                    onClick={() => this.handleConfirm()}
                                >
                                    {isConfirmed ? '\u2713 Confirmed' : 'Confirm Details'}
                                </button>
                            </div>
                        </div>

                        {isConfirmed && (
                            <div className="alert alert-success mt-3 mb-0 py-2 text-center">
                                Details confirmed! You can now place your order.
                            </div>
                        )}
                        </>
                    )}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="site-wrap">
                <Header />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0">
                                <a href={`school/${this.props.school.name}`}>Home</a>
                                <span className="mx-2 mb-0">/</span>
                                <a href="cart">Cart</a>
                                <span className="mx-2 mb-0">/</span>
                                <strong className="text-black">Checkout</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 mb-5 mb-md-0">
                                {this.state.step === 1 ? this.renderStep1() : this.renderStep2()}
                            </div>
                            <div className="col-md-6">
                                <div className="row mb-5">
                                    <div className="col-md-12">
                                        <h2 className="h3 mb-3 text-black">Your Order</h2>
                                        <div className="p-3 p-lg-5 border">
                                            <table className="table site-block-order-table mb-5">
                                                <thead>
                                                    <tr>
                                                        <th>Product</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.cartProducts.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td>{item.productSetName}</td>
                                                            <td>&#8377;{item.price}</td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td className="text-black font-weight-bold"><strong>Order Total</strong></td>
                                                        <td className="text-black font-weight-bold"><strong>&#8377;{this.state.orderTotal}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-black"><strong>{this.state.cartProducts[0]?.orderType === 'uniformProducts' ? 'Uniform Shipping Charges' : 'Shipping Charges'}</strong></td>
                                                        <td className="text-black"><strong>&#8377;{(this.state.cartProducts[0]?.orderType === 'uniformProducts' ? (this.props.school.uniformCharges || 0) : (this.props.school.shippingCharges || 0)) * this.state.cartProducts.length}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-black font-weight-bold"><strong>Final Order Total</strong></td>
                                                        <td className="text-black font-weight-bold"><strong>&#8377;{this.state.orderTotal + ((this.state.cartProducts[0]?.orderType === 'uniformProducts' ? (this.props.school.uniformCharges || 0) : (this.props.school.shippingCharges || 0)) * this.state.cartProducts.length)}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            {this.state.step === 1 && (
                                                <div className="alert alert-warning text-center py-2">
                                                    Please enter your email and click Next to proceed with the checkout.
                                                </div>
                                            )}

                                            {this.state.step === 2 && !this.state.isConfirmed && (
                                                <div className="alert alert-warning text-center py-2">
                                                    Please confirm your details before placing the order.
                                                </div>
                                            )}

                                            <div className="form-group">
                                                <button
                                                    className="btn btn-primary btn-lg py-3 btn-block"
                                                    onClick={() => this.handlePlaceOrder()}
                                                    disabled={!this.state.isConfirmed}
                                                >
                                                    Place Order
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        products: getCartProducts(state),
        isAuthenticated: getisAuthenticated(state),
        user: getUserData(state),
        school: getSchool(state),
    }
}

const mapDispatchToProps = dispatch => ({
    clearCart: () => dispatch(clearCart()),
    login: (email) => dispatch(loginUser(email)),
    loginWithData: (userData) => dispatch(loginWithData(userData)),
    setParentSchools: (schools) => dispatch(setParentSchools(schools)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Checkout);
